<template>
  <v-chip
    ref="chip"
    :color="color"
    data-testid="so-chip"
    density="comfortable"
    style="min-width: fit-content"
    :size="size"
    :variant="type === SoChipType.FILTER ? 'outlined' : undefined"
    :closable="type === SoChipType.FILTER"
    @click:close="$emit('close')"
  >
    <div class="text-body-2">{{ text }}</div>
  </v-chip>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { SoChipType } from "@/types/components/SoChip"

  export type SoChipProps = {
    type: SoChipType
    text: string
    size?: string
  }

  export default defineComponent({
    props: {
      type: {
        type: String as PropType<SoChipType>,
        default: SoChipType.DEFAULT,
        required: false,
      },
      text: {
        type: String,
        default: "",
        required: true,
      },
      size: {
        type: String,
        default: undefined,
      },
    },
    emits: ["close"],
    data() {
      return { SoChipType }
    },
    computed: {
      color() {
        switch (this.type) {
          case SoChipType.SUCCESS:
            return "success"
          case SoChipType.ERROR:
            return "error"
          case SoChipType.IMPORTANT:
            return "primary"
          case SoChipType.WARNING:
            return "caution"
          case SoChipType.DEFAULT:
            return ""
          case SoChipType.FILTER:
            return "primary"
          default:
            return ""
        }
      },
    },
  })
</script>
